// JWT helpers — decode the payload and reason about expiry.

export const decodeToken = (token) => {
  try {
    const [, payload] = token.split(".");
    return JSON.parse(atob(payload));
  } catch {
    return null;
  }
};

// Expiry in milliseconds (JWT `exp` is in seconds), or null if not present.
export const getTokenExpiryMs = (token) => {
  const payload = decodeToken(token);
  return payload?.exp ? payload.exp * 1000 : null;
};

export const isTokenExpired = (token) => {
  const expiry = getTokenExpiryMs(token);
  // Treat a token with no decodable expiry as expired.
  return expiry ? Date.now() >= expiry : true;
};
